<template>
    <div>
        <h1>CENSO</h1>

        <div class="d-flex">

            <v-btn @click="cargar" class="mr-2 primary ">cargar</v-btn>
            <v-btn @click="cargarEstadosCensos" class="mr-2">Estados</v-btn>
            <Consulta :censado="censado"/>
        </div>

        <div v-if="censos.length > 0" disabled>

            <v-data-table :headers="headers" :items="censos" :loading="loading" hide-default-footer>
                <template v-slot:[`item.faltantes`]="props">
                    <ul class="red--text">
                        <li v-if="!props.item.direccion || props.item.direccion.length < 2">direccion</li>
                        <li v-if="!props.item.localidad || props.item.localidad.length < 2">localidad</li>
                        <li v-if="!props.item.cedula || props.item.cedula.length < 1">cedula</li>
                        <li v-if="!props.item.feVida || props.item.feVida.length < 10">fe vida</li>
                        <!-- <li v-if="!props.item.logFeVida">fe vida</li> -->
                    </ul>
                </template>
                <template v-slot:[`item.actions`]="props">
                    <v-btn v-if="props" :disabled="loading" small class="mr-2" color="primary"
                        @click="censado(props.item)">Censado</v-btn>
                    <v-btn v-if="props" :disabled="loading" small color="warning" @click="noEncontrado(props.item)">No
                        encontrado</v-btn>
                </template>
            </v-data-table>

        </div>

        <v-dialog scrollable max-width="600px" v-model="showDialog">

            <v-card v-if="itemCenso">
                <v-card-title>
                    {{ itemCenso.nombreCompleto }}
                </v-card-title>
                <v-card-text>
                    <v-text-field type=text label="Observacion" v-model="observacion" autofocus />
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="info" @click="volver">Volver</v-btn>
                    <v-btn color="info" @click="confirmarNoEncontrado" :loading="loading">Confirmar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>



        <v-dialog scrollable max-width="600px" v-model="showEstadosCensos">

            <v-card>
                <v-card-title>
                    <!-- <h4>Ingrese la observacion</h4> -->
                </v-card-title>
                <v-card-text>
                    <v-data-table :headers="headersEstados" :items="estadosCensos" hide-default-footer>
                    </v-data-table>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="info" @click="showEstadosCensos = false">Volver</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


    </div>
</template>

<script>

import axios from "axios";
import Consulta from "@/components/censo/Consulta.vue";

export default {
    data() {
        return {
            headers: [
                { text: "CodMem", value: "codMemSq" },
                { text: "MemType", value: "memType" },
                { text: "Celular", value: "celular" },
                { text: "Nombres", value: "nombreCompleto" },
                { text: "Faltantes", value: "faltantes" },
                { text: "Accion", value: "actions", sortable: false },
            ],

            headersEstados: [
                { text: "Usuario", value: "usuario" },
                { text: "CENSADOS", value: "censado" },
                { text: "NO ENCONTRADOS", value: "noEncontrado" },
                { text: "PENDIENTE", value: "pendiente" },
            ],
            censos: [],
            errorMessage: "",
            showDialog: false,
            showEstadosCensos: false,
            loading: false,
            observacion: "",
            estadosCensos: [],
            itemCenso: null,
        };
    },
    mounted() {
        this.iniciar();
    },
    methods: {
        async iniciar() {
            this.loading = true;
            const res = await axios.get('censo/bandeja');
            this.censos = res.data;
            this.loading = false;
        },
        async cargar() {
            this.loading = true;
            const res = await axios.post('censo/cargar10');
            this.censos = res.data;
            this.loading = false;
        },
        async censado(censo) {
            const confirm = window.confirm('¿Marcar como CENSADO a ' + censo.nombres + '?');
            if (!confirm) return;



            this.loading = true;
            await axios.post('censo/' + censo.id + '/estado', { estado: 'CENSADO' });
            this.censos = this.censos.filter(c => c.id != censo.id);
            this.loading = false;
        },
        async confirmarNoEncontrado() {


            // const confirm = window.confirm('¿Marcar como NO ENCONTRADO a ' + censo.nombres + '?');
            // if (!confirm) return;

            this.loading = true;
            await axios.post('censo/' + this.itemCenso.id + '/estado', { estado: 'NO_ENCONTRADO', observacion: this.observacion });
            this.censos = this.censos.filter(c => c.id != this.itemCenso.id);
            this.itemCenso = null;
            this.observacion = "";
            this.loading = false;
            this.showDialog = false;

        },
        noEncontrado(item) {
            this.itemCenso = item;
            this.showDialog = true;
        },
        volver() {
            this.observacion = "";
            this.showDialog = false;
        },
        async cargarEstadosCensos() {
            this.showEstadosCensos = true;
            const res = await axios.get('/censo/estadosCensos')
            this.estadosCensos = res.data;
        },
    },
    components: {
        Consulta
    }
}

</script>